<template>
  <div>
    <h5 class="headline">{{ $t("contract.patent_and_trademark.headline") }}</h5>
    <p>{{ $t("contract.patent_and_trademark.paragraph_one") }}</p>
    <p>{{ $t("contract.patent_and_trademark.paragraph_two") }}</p>
    <p>{{ $t("contract.patent_and_trademark.paragraph_three") }}</p>
    <p v-if="!isDistributor">{{ $t("contract.patent_and_trademark.paragraph_four") }}</p>
    <hr />
  </div>
</template>

<script>
export default {
  computed: {
    isDistributor() {
      return this.$store.getters.isDistributorType;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/contract/PatentAndTrademarkOutput.vue